import { Box, Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import Page from 'src/components/page/page';
import useBannerDetails from './banner-details.hook';
import CNLoading from 'src/components/loading-cn/CNLoading';
import BannerForm from './components/banner-form';

export default function BannerDetails() {
  const {
    isLoadingBannerDetails,
    methods,
    onSubmit,
    handleDropUrl,
    handleRemove,
    handleRemoveAll,
    isSubmitting,
  } = useBannerDetails();
  return (
    <Page title="Detalhes do banner">
      <Container maxWidth="lg">
        <HeaderBreadcrumbs heading="Editar Banner" links={[]} />
      </Container>
      {isLoadingBannerDetails ? (
        <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
          <CNLoading />
        </Box>
      ) : (
        <BannerForm
          methods={methods}
          onSubmit={onSubmit}
          handleDropUrl={handleDropUrl}
          handleRemove={handleRemove}
          handleRemoveAll={handleRemoveAll}
          isSubmitting={isSubmitting}
        />
      )}
    </Page>
  );
}
